var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mac_kucun_list',{attrs:{"caozuo_flag_props":3,"xiugai_type":1,"show_type":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }